import { PipeTransform, Pipe } from '@angular/core';

// Takes a pure function and it's inputs for computation and use in a template
// This prevents the function from being evaluated on every change detection cycle,
// and instead only when inputs change
@Pipe({name: 'pureFunction'})
export class PureFunctionPipe implements PipeTransform {
  transform<T, U>(
      fnc: (...args: U[]) => T, // use rest parameter to take a generic number of inputs for a function
      ...args: U[]): T { // second argument of the pipe itself is the arguments to be used in the function

    return fnc(...args); // compute the function
  }
}
